import { createReducer } from 'redux-create-reducer';

import { CHECK_USER_ACTIVITY } from '../types';

const initialState = {
  result: '',
  isCompleted: false,
};
const userActivityReducer = createReducer(initialState, {
  [CHECK_USER_ACTIVITY.DEFAULT]: state => ({
    ...state,
    isCompleted: false,
  }),
  [CHECK_USER_ACTIVITY.PENDING]: state => ({
    ...state,
    isCompleted: false,
  }),
  [CHECK_USER_ACTIVITY.REJECTED]: state => ({
    ...state,
    isCompleted: false,
  }),
  [CHECK_USER_ACTIVITY.FULFILLED]: (state, { payload }) => ({
    ...state,
    result: payload.data,
    isCompleted: true,
  }),
});

export default userActivityReducer;


// WEBPACK FOOTER //
// ./src/reducers/userActivityReducer.js